<template>
    <div class="control-body collapse" id="collapse-search-results" data-bs-parent="#mapOverlay">
        <div class="search-results-list">
            <p class="search-results-count">
                {{ results.length }} {{ $t('overlay.searchResults') }}
            </p>
            <a href="#" class="search-result" v-for="item in results" :key="item.uid" @click="$emit('emitSelect', item.uniqueIdentifier)" data-bs-toggle="collapse" data-bs-target="#collapse-search-results">
                {{ item.title }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchResults',
    data() {
        return {
            results: [],
            searchLength: 0
        }
    },
    mounted() {
        // Listen for search results from Map component
        window.addEventListener('searchResultsUpdated', (event) => {
            this.results = event.detail;
        });
        window.addEventListener('searchLengthUpdated', (event) => {
            this.searchLength = event.detail;
        });
    },
    beforeUnmount() {
        window.removeEventListener('searchResultsUpdated', this.handleSearchResults);
        window.removeEventListener('searchLengthUpdated', this.handleSearchLength);
    },
    methods: {
    },
    watch: {
        searchLength(newValue, oldValue) {
            if(newValue > 3){
                $("#collapse-search-results").collapse("show");
            } else {
                $("#collapse-search-results").collapse("hide");
            }
        }
    }
}
</script>

<style scoped>
.search-results-list {
    padding: 10px;
}
.search-result {
    display: block;
    padding: 8px;
    text-decoration: none;
    color: inherit;
}
.search-result:hover {
    background-color: rgba(0, 0, 0, 0.05);
}
</style> 